import agentsPossibilitiesCover from '../assets/event-cover-agents-possibilities.png';
import infraDemoNight from '../assets/event-cover-infra-demo-night.jpg';
import hackathonCover from '../assets/luma-cover.png';
import agentsPossibilities01Avif from '../assets/reel/agents-possibilities-01.avif';
import agentsPossibilities01 from '../assets/reel/agents-possibilities-01.jpg';
import agentsPossibilities02Avif from '../assets/reel/agents-possibilities-02.avif';
import agentsPossibilities02 from '../assets/reel/agents-possibilities-02.jpg';
import agentsPossibilities03Avif from '../assets/reel/agents-possibilities-03.avif';
import agentsPossibilities03 from '../assets/reel/agents-possibilities-03.jpg';
import agentsPossibilities04Avif from '../assets/reel/agents-possibilities-04.avif';
import agentsPossibilities04 from '../assets/reel/agents-possibilities-04.jpg';
import agentsPossibilities05Avif from '../assets/reel/agents-possibilities-05.avif';
import agentsPossibilities05 from '../assets/reel/agents-possibilities-05.jpg';
import agentsPossibilities06Avif from '../assets/reel/agents-possibilities-06.avif';
import agentsPossibilities06 from '../assets/reel/agents-possibilities-06.jpg';
import agentsPossibilities07Avif from '../assets/reel/agents-possibilities-07.avif';
import agentsPossibilities07 from '../assets/reel/agents-possibilities-07.jpg';
import agentsPossibilities08Avif from '../assets/reel/agents-possibilities-08.avif';
import agentsPossibilities08 from '../assets/reel/agents-possibilities-08.jpg';
import agentsPossibilities09Avif from '../assets/reel/agents-possibilities-09.avif';
import agentsPossibilities09 from '../assets/reel/agents-possibilities-09.jpg';
import reel01Avif from '../assets/reel/reel-01.avif';
import reel01 from '../assets/reel/reel-01.jpg';
import reel02Avif from '../assets/reel/reel-02.avif';
import reel02 from '../assets/reel/reel-02.jpg';
import reel03Avif from '../assets/reel/reel-03.avif';
import reel03 from '../assets/reel/reel-03.jpg';
import reel04Avif from '../assets/reel/reel-04.avif';
import reel04 from '../assets/reel/reel-04.jpg';
import reel05Avif from '../assets/reel/reel-05.avif';
import reel05 from '../assets/reel/reel-05.jpg';
import reel06Avif from '../assets/reel/reel-06.avif';
import reel06 from '../assets/reel/reel-06.jpg';
import reel07Avif from '../assets/reel/reel-07.avif';
import reel07 from '../assets/reel/reel-07.jpg';
import reel08Avif from '../assets/reel/reel-08.avif';
import reel08 from '../assets/reel/reel-08.jpg';
import reel09Avif from '../assets/reel/reel-09.avif';
import reel09 from '../assets/reel/reel-09.jpg';

export type EventLinks = {
  /** Internal page on this site (e.g. the hackathon recap). */
  page?: string;
  /** Luma event / RSVP page. */
  luma?: string;
  /** Google Calendar invite link. */
  calendar?: string;
  /** Social post — LinkedIn, Instagram, etc. */
  social?: string;
  /** Map/search link for the physical venue. */
  location?: string;
  /** Project-submission page (e.g. a demo night's submission form). */
  submit?: string;
};

export type CommunityEvent = {
  title: string;
  format: string;
  venue: string;
  /** Speaker for a talk-session, if any. */
  speaker?: string;
  /** Public profile for the speaker. */
  speakerLinkedIn?: string;
  /** Credited people or organizations, e.g. judges and sponsors. */
  credits?: EventCreditGroup[];
  /** Extra detail lines shown under the title (e.g. judges, sponsors). */
  details?: string[];
  /** Display date, e.g. "May 17, 2026". Omit when not yet confirmed. */
  date?: string;
  /** Event time. */
  time?: string;
  cover?: string;
  status: 'upcoming' | 'past';
  /** Prominent upcoming events render as feature cards. */
  prominent?: boolean;
  links?: EventLinks;
};

export type EventCredit = {
  name: string;
  href?: string;
};

export type EventCreditGroup = {
  label: string;
  items: EventCredit[];
};

const BLDR_SPACE_LOCATION =
  'https://www.google.com/maps/search/?api=1&query=Bldr%20Space%20Amman';
const BLDR_WEIBDEH_LOCATION =
  'https://www.google.com/maps/search/?api=1&query=Bldr%20Space%20Al-Weibdeh%20Amman%20Jordan';
const BLDR_MECCA_LOCATION =
  'https://www.google.com/maps/search/?api=1&query=Bldr%20Space%2033%20Mecca%20Street%20Amman%20Jordan';
const ALMOND_RABYEH_LOCATION =
  'https://www.google.com/maps/search/?api=1&query=Almond%20Coffee%20House%20Rabyeh%20Naim%20Abdul%20Hadi%20St.%2024%20Amman%20Jordan';
const ALMOND_8TH_CIRCLE_LOCATION =
  'https://www.google.com/maps/search/?api=1&query=Almond%20Coffee%20House%208th%20Circle%20Amman%20Jordan';

/**
 * Community events in chronological order (oldest first). Index numbers in the
 * UI are derived from this order, so adding or reordering an event renumbers
 * the ledger automatically.
 *
 * Reconstructed from The Agent Lab's LinkedIn history and direct community
 * announcements. Older talk dates without announcements are approximate months
 * from post recency.
 *
 * TODO: replace approximate dates with exact ones, add luma/calendar/social
 * links, and fill in date/time/cover/registration for the upcoming events.
 */
export const events: CommunityEvent[] = [
  {
    title: 'Community Networking Meetup',
    format: 'Networking',
    venue: 'Almond Coffee House - Rabyeh, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: ALMOND_RABYEH_LOCATION },
  },
  {
    title: 'AGI',
    format: 'Networking',
    venue: 'Almond Coffee House - Rabyeh, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: ALMOND_RABYEH_LOCATION },
  },
  {
    title: 'Community Networking Meetup',
    format: 'Networking',
    venue: 'Almond Coffee House - 8th Circle, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: ALMOND_8TH_CIRCLE_LOCATION },
  },
  {
    title: 'Community Networking Meetup',
    format: 'Networking',
    venue: 'Almond Coffee House - Rabyeh, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: ALMOND_RABYEH_LOCATION },
  },
  {
    title: 'Community Networking Meetup',
    format: 'Networking',
    venue: 'Almond Coffee House - Rabyeh, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: ALMOND_RABYEH_LOCATION },
  },
  {
    title: 'Everyone Is Building Multi-Agent Architectures Wrong',
    speaker: 'Ismail Alarmouti',
    speakerLinkedIn: 'https://www.linkedin.com/in/armouti',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title: 'Building Agentic Systems Pragmatically',
    speaker: 'Hassan Abu Alhaj',
    speakerLinkedIn: 'https://www.linkedin.com/in/hassan-abualhaj',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title: 'Eval Basics',
    speaker: 'Ezz Abuzaid',
    speakerLinkedIn: 'https://www.linkedin.com/in/ezzabuzaid',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Jan 11, 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title:
      'Compressing Years of Messy Institutional Work with an Agentic System',
    speaker: 'Ismail Alarmouti',
    speakerLinkedIn: 'https://www.linkedin.com/in/armouti',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Early 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title: 'An Introduction to Graph RAG',
    speaker: 'Ahmad Almashni',
    speakerLinkedIn: 'https://www.linkedin.com/in/ahmad-almashni-481041151',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Feb 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title: 'UX Design for Agentic Experiences',
    speaker: 'Hussein ElRyalat',
    speakerLinkedIn: 'https://www.linkedin.com/in/hussc',
    format: 'Talk',
    venue: 'Bldr Space, Amman',
    date: 'Apr 12, 2026',
    status: 'past',
    links: { location: BLDR_SPACE_LOCATION },
  },
  {
    title: 'AI Engineering Hackathon',
    format: 'Hackathon',
    venue: 'Bldr Space, Al-Weibdeh',
    date: 'Apr 25, 2026',
    cover: hackathonCover,
    status: 'past',
    credits: [
      {
        label: 'Judges',
        items: [
          {
            name: 'Tambi Jalouqa',
            href: 'https://jo.linkedin.com/in/tambijalouqa',
          },
          {
            name: 'Lamia Shreim',
            href: 'https://jo.linkedin.com/in/lamia-shreim-386028a4',
          },
          {
            name: 'Abdulrahman Zeineddin',
            href: 'https://www.linkedin.com/in/abdurahmanzeineddin',
          },
        ],
      },
      {
        label: 'Sponsors',
        items: [
          { name: 'Bldr Space', href: 'https://www.bldr.space/' },
          { name: 'JOSA', href: 'https://josa.ngo/' },
          { name: '73 by Al Ameed', href: 'https://seventythree.coffee/' },
          { name: 'limerence.sh', href: 'https://limerence.sh/' },
          { name: 'Symploc', href: 'https://symploc.com/' },
          { name: 'Phi Science', href: 'https://www.phi.science/' },
        ],
      },
    ],
    links: { page: '/hackathon', location: BLDR_WEIBDEH_LOCATION },
  },
  {
    title: 'Agentic Data Science',
    speaker: 'Anas Barghouthy',
    speakerLinkedIn: 'https://www.linkedin.com/in/anasbarg',
    format: 'Talk',
    venue: 'Bldr Space, Mecca Street',
    date: 'May 10, 2026',
    status: 'past',
    links: {
      luma: 'https://luma.com/7vbt75te',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title: 'Community Networking Meetup',
    format: 'Networking',
    venue: 'Almond Coffee House - Rabyeh, Amman',
    date: 'May 23, 2026',
    status: 'past',
    details: [
      'A relaxed meetup for meeting people, exchanging ideas, sharing work, and connecting around hiring, job-search, and new opportunities.',
    ],
    links: {
      calendar: 'https://calendar.app.google/PhR36ZDLSP98cmudA',
      location: ALMOND_RABYEH_LOCATION,
    },
  },
  {
    title: 'What Happens When Your Agent Calls a Model',
    speaker: 'Omar Al-Azizi',
    speakerLinkedIn: 'https://www.linkedin.com/in/omar-al-azizi-3521b3241',
    format: 'Talk',
    venue: 'Bldr Space, Mecca Street',
    date: 'Jun 7, 2026',
    status: 'past',
    links: { location: BLDR_MECCA_LOCATION },
  },
  {
    title: 'Economics of AI and the Viability of AI Companies',
    format: 'Coffee Discussion',
    venue: 'Bldr Space, Mecca Street',
    date: 'Jun 21, 2026',
    status: 'past',
    details: [
      'A coffee discussion on AI economics and the long-term viability of AI companies, not a presentation session.',
    ],
    links: {
      calendar: 'https://calendar.app.google/tYfRox9WtXt4r5EF7',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title:
      'Platform Engineering: A Strict Prerequisite for an Enterprise Agentic Software Factory',
    format: 'Meetup',
    venue: 'Bldr Space, Mecca Street',
    date: 'Aug 9, 2026',
    time: '6:45–8:45 PM',
    status: 'upcoming',
    prominent: true,
    links: {
      calendar:
        'https://www.google.com/calendar/event?eid=NzYwbWl0MmhmZm9lczEycG8xbjA3cTJwa2lfMjAyNjA4MDJUMTYwMDAwWiBlenphYnV6YWlkQG0',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title: 'Cursor Day',
    format: 'Meetup',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Speed Matching: Fresh Grads & Companies',
    format: 'Networking',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Pitch Your Project',
    format: 'Pitch Session',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Claude Maxing',
    format: 'Build Coffee',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Rethinking ChatBot UI/UX',
    format: 'Build Coffee',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Bench Week',
    format: 'Hackathon',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'BioHack',
    format: 'Hackathon',
    venue: 'Amman',
    status: 'upcoming',
  },
  {
    title: 'Infra Demo Night',
    format: 'Demo Night',
    venue: 'Bldr Space, Mecca Street',
    date: 'Jul 11, 2026',
    cover: infraDemoNight,
    status: 'upcoming',
    prominent: true,
    credits: [
      {
        label: 'In partnership with',
        items: [{ name: 'Propeller', href: 'https://propellerinc.me/' }],
      },
    ],
    details: [
      'Meet engineers, builders, founders, and dev-tooling people, and watch teams demo what they are building.',
      'Bring side projects, open-source work, and engineering problems. Share what broke, the tradeoffs you made, and what you learned.',
    ],
    links: {
      luma: 'https://luma.com/f4jd813j',
      submit: 'https://init.propellerinc.me/demo-nights/demo-night-amman',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title: 'What Was Impractical Before Agents and Is Now Possible?',
    format: 'Coffee Discussion',
    venue: 'Bldr Space, Mecca Street',
    date: 'Jul 26, 2026',
    time: '7:00 PM',
    cover: agentsPossibilitiesCover,
    status: 'upcoming',
    prominent: true,
    details: [
      'Explore where AI agents can create meaningful leverage in healthcare and education.',
    ],
    links: {
      luma: 'https://luma.com/qpu4adrv',
      calendar: 'https://calendar.app.google/74xM6qo1ggKw5R6MA',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title: 'Specialization, Generalization & the Expectation Bar',
    format: 'Meetup',
    venue: 'Bldr Space, Mecca Street',
    date: 'Aug 23, 2026',
    time: '6:45–8:45 PM',
    status: 'past',
    details: [
      'A community discussion on whether engineers should specialize or generalize, what juniors should focus on, and how AI is changing expectations for individual contributors.',
    ],
    links: {
      social: 'https://lnkd.in/p/d2NsmGpa',
      location: BLDR_MECCA_LOCATION,
    },
  },
  {
    title: 'Harness & Pizza',
    format: 'Workshop',
    venue: 'Bldr Space, Mecca Street',
    date: 'Sep 5, 2026',
    time: '11:00 AM–5:00 PM',
    status: 'past',
    details: [
      'Harnesses, experiments, good conversations, and pizza. Test ideas, build together, and share what works.',
    ],
    links: { location: BLDR_MECCA_LOCATION },
  },
  {
    title: 'Network & Showcase',
    format: 'Networking & Showcase',
    venue: 'Almond Coffee House - Rabyeh rooftop, Amman',
    date: 'Sep 19, 2026',
    time: '6:00–8:00 PM',
    status: 'past',
    details: [
      'A relaxed evening of networking, project showcases, and exchanging ideas with the people building them.',
    ],
    credits: [
      {
        label: 'Projects',
        items: [
          { name: 'Mizanlabs', href: 'https://mizanlabs.dev/' },
          { name: 'Cortad', href: 'https://cortad.com/' },
          { name: 'HeyAgents', href: 'https://heyagents.app/' },
        ],
      },
    ],
    links: {
      luma: 'https://luma.com/v7fki5i1',
      social: 'https://lnkd.in/p/dHHAufVZ',
      location: ALMOND_RABYEH_LOCATION,
    },
  },
  {
    title: 'Product Engineers vs. PMs + Software Engineers',
    format: 'Debate',
    venue: 'Bldr Space, Mecca Street',
    date: 'Oct 17, 2026',
    time: '6:30–8:30 PM',
    status: 'upcoming',
    prominent: true,
    details: [
      'A debate on whether early-stage startups should build teams of product engineers or keep product managers and software engineers as separate roles.',
      // Source and review gaps: event-publications/product-engineers-debate-recap-review.md.
      'Hot takes from the final event slides, in slide order:',
      '“AI sped up the code. The PM–engineer handoff is now the bottleneck.”',
      '“Subject-matter experts are the new product engineers.”',
      '“Engineers suffer from solution bias.”',
      '“Product engineering is burnout disguised as efficiency.”',
      '“AI lets PMs build fast—until they hit a problem they can’t diagnose.”',
      '“AI should turn PMs into builders and engineers into architects.”',
    ],
    links: {
      luma: 'https://luma.com/cz1ohaif',
      location: BLDR_MECCA_LOCATION,
    },
  },
];

export type NumberedEvent = CommunityEvent & { index: string };

function hasPassed(date?: string): boolean {
  if (!date) return false;
  const time = Date.parse(date);
  if (Number.isNaN(time)) return false;
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return time < startOfToday.getTime();
}

/**
 * An `upcoming` event folds into the past once its exact date has passed.
 * Fuzzy dates like "Early 2026" don't parse, so those keep their manual
 * `status` and must be flipped by hand.
 */
function effectiveStatus(event: CommunityEvent): 'upcoming' | 'past' {
  if (event.status === 'past') return 'past';
  return hasPassed(event.date) ? 'past' : 'upcoming';
}

const numbered: NumberedEvent[] = events.map((event, i) => ({
  ...event,
  status: effectiveStatus(event),
  index: String(i + 1).padStart(2, '0'),
}));

/** Upcoming events, soonest first. */
export const upcomingEvents = numbered.filter((e) => e.status === 'upcoming');

/** Prominent upcoming events render as cards. */
export const prominentUpcomingEvents = upcomingEvents.filter(
  (e) => e.prominent,
);

/** Non-prominent upcoming events render as a compact list. */
export const regularUpcomingEvents = upcomingEvents.filter((e) => !e.prominent);

/** Past events, most recent first. */
export const pastEvents = numbered.filter((e) => e.status === 'past').reverse();

export function eventHref(event: CommunityEvent): string | undefined {
  return (
    event.links?.page ??
    event.links?.luma ??
    event.links?.social ??
    event.links?.calendar
  );
}

export type ReelMedia =
  | {
      type: 'image';
      src: string;
      avifSrc: string;
      alt: string;
    }
  | {
      type: 'video';
      /** Imported asset URL for a short, muted, loop-friendly clip. */
      src: string;
      alt: string;
    };

/**
 * The auto-scrolling reel at the top of the events page — photos from past
 * meetups. To add a short clip, import it above and add an entry with
 * { type: 'video', src: <import>, alt: '…' }. Landscape crops best (items
 * render in a ~16:10 frame).
 */
export const reelMedia: ReelMedia[] = [
  {
    type: 'image',
    src: agentsPossibilities01,
    avifSrc: agentsPossibilities01Avif,
    alt: 'The Agent Lab community networking before the agents discussion',
  },
  {
    type: 'image',
    src: agentsPossibilities02,
    avifSrc: agentsPossibilities02Avif,
    alt: 'Attendees at the agents discussion',
  },
  {
    type: 'image',
    src: agentsPossibilities03,
    avifSrc: agentsPossibilities03Avif,
    alt: 'Small-group discussion at The Agent Lab',
  },
  {
    type: 'image',
    src: agentsPossibilities04,
    avifSrc: agentsPossibilities04Avif,
    alt: 'The Agent Lab agents discussion welcome board',
  },
  {
    type: 'image',
    src: agentsPossibilities05,
    avifSrc: agentsPossibilities05Avif,
    alt: 'A participant speaking at the agents discussion',
  },
  {
    type: 'image',
    src: agentsPossibilities06,
    avifSrc: agentsPossibilities06Avif,
    alt: 'Participants presenting at the agents discussion',
  },
  {
    type: 'image',
    src: agentsPossibilities07,
    avifSrc: agentsPossibilities07Avif,
    alt: 'A participant sharing ideas at the agents discussion',
  },
  {
    type: 'image',
    src: agentsPossibilities08,
    avifSrc: agentsPossibilities08Avif,
    alt: 'A participant speaking at The Agent Lab',
  },
  {
    type: 'image',
    src: agentsPossibilities09,
    avifSrc: agentsPossibilities09Avif,
    alt: 'Attendees listening during the agents discussion',
  },
  {
    type: 'image',
    src: reel01,
    avifSrc: reel01Avif,
    alt: 'A talk at a The Agent Lab meetup',
  },
  {
    type: 'image',
    src: reel02,
    avifSrc: reel02Avif,
    alt: 'A talk at a The Agent Lab meetup',
  },
  {
    type: 'image',
    src: reel03,
    avifSrc: reel03Avif,
    alt: 'The Agent Lab community group photo',
  },
  {
    type: 'image',
    src: reel04,
    avifSrc: reel04Avif,
    alt: 'A GraphRAG talk at The Agent Lab',
  },
  {
    type: 'image',
    src: reel05,
    avifSrc: reel05Avif,
    alt: 'Attendees at a The Agent Lab session',
  },
  {
    type: 'image',
    src: reel06,
    avifSrc: reel06Avif,
    alt: 'A talk at a The Agent Lab meetup',
  },
  {
    type: 'image',
    src: reel07,
    avifSrc: reel07Avif,
    alt: 'A talk at a The Agent Lab meetup',
  },
  {
    type: 'image',
    src: reel08,
    avifSrc: reel08Avif,
    alt: 'The Agent Lab members networking',
  },
  {
    type: 'image',
    src: reel09,
    avifSrc: reel09Avif,
    alt: 'A talk at a The Agent Lab meetup',
  },
];
